import { MessageSquare } from 'lucide-react';

interface ApprovalSlotCommentsProps {
    comments: string;
    status: 'pending' | 'approved' | 'rejected';
}

// Configuration object for status-based styling
const statusStyles = {
    approved: {
        container: 'bg-green-50 border border-green-200',
        icon: 'bg-green-200 text-green-700',
        comment: 'bg-white border border-green-100 text-green-900'
    },
    rejected: {
        container: 'bg-red-50 border border-red-200',
        icon: 'bg-red-200 text-red-400',
        comment: 'bg-white border border-red-100 text-red-900'
    },
    pending: {
        container: 'bg-gray-50 border border-gray-200',
        icon: 'bg-gray-300 text-gray-600',
        comment: 'bg-white border border-gray-100 text-gray-800'
    }
} as const;

const ApprovalSlotComments: React.FC<ApprovalSlotCommentsProps> = ({
    comments,
    status
}) => {
    const styles = statusStyles[status];
    // Extract text color from icon styles for the MessageSquare icon
    const iconTextColor = styles.icon.split(' ').find(cls => cls.startsWith('text-')) || 'text-gray-600';

    return (
        <div>
                <div className="flex flex-row gap-1 items-center mb-1">
                    <MessageSquare className={`h-3.5 w-3.5 sm:h-4 sm:w-4 ${iconTextColor}`} />
                    <p className="text-xs sm:text-sm text-gray-600 font-medium">ความคิดเห็น:</p>
                </div>
                <div className={`text-sm sm:text-base break-words leading-relaxed p-2 sm:p-3 rounded-md ${styles.comment}`}>
                    {comments}
                </div>
            </div>
    );
};

export default ApprovalSlotComments;
